import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const systemManagementUpdateService = (data: any) => {
  return axiosInstance
    .put(ENDPOINTS.ADMIN.SYSTEM.MANAGEMENT.UPDATE, data)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
